// react
import React, { Fragment, useEffect, useReducer, useState } from 'react';

// styles
import styles from './index.module.scss';
// components
import { NavHeader } from '../../../components/navHeader/index';
import { QuizItem } from '../../../components/quizItem';
import { BtnSmall } from '../../../components/btns/btnSmall';
// reducer
import {
  quizPageStatesInitialState,
  quizPageStatesReducer,
} from './indexReducer';
// MUI
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
// router
import { useNavigate } from 'react-router-dom';
// redux
import { useSelector } from 'react-redux';
// services
import {
  getQuizService,
  submitQuizService,
} from '../../../services/userService';
/***************************************************************************/
/* Name : QuizPage React Component */
/***************************************************************************/
const QuizPage = React.memo(() => {
  const navigate = useNavigate();
  // reducer
  const [quizPageStates, dispatchQuizPageStates] = useReducer(
    quizPageStatesReducer,
    quizPageStatesInitialState
  );
  const [studentData, setStudentData] = useState(
    useSelector((state) => state.ui.studentData)
  );
  const [quizArray, setQuizArray] = useState([]);
  const [answersObj, setAnswersObj] = useState({});
  /******************************************************************/
  /* useEffect */
  /******************************************************************/
  useEffect(() => {
    (async () => {
      if (studentData.length === 0) {
        // navigate to dashboard
        navigate('/');
      }
      await getQuizQuestions();
    })();
  }, []);

  /******************************************************************/
  /* getQuizQuestions */
  /******************************************************************/
  const getQuizQuestions = async () => {
    dispatchQuizPageStates({ type: 'PENDING' });
    const response = await getQuizService();
    if (response.status === 'success') {
      dispatchQuizPageStates({ type: 'CLEAR' });
      // set quizArray
      setQuizArray(response.questionsArray);
    } else {
      dispatchQuizPageStates({
        type: 'ERROR',
        errorMessage: response.message,
      });
    }
  };
  /******************************************************************/
  /* handleCloseSnackbar */
  /******************************************************************/
  const handleCloseSnackbar = () => {
    dispatchQuizPageStates({ type: 'CLEAR' });
  };
  /******************************************************************/
  /* submitResultsHandler */
  /******************************************************************/
  const submitResultsHandler = async () => {
    // if the answersObj is less than 4
    if (Object.keys(answersObj).length < 4) {
      dispatchQuizPageStates({
        type: 'ERROR',
        errorMessage: 'يجب اجابة جميع الاسئلة',
      });
      return;
    }
    dispatchQuizPageStates({ type: 'PENDING' });
    const response = await submitQuizService(answersObj);
    if (response.status === 'success') {
      dispatchQuizPageStates({
        type: 'SUCCESS',
        successMessage: response.message,
      });
      // navigate to dashboard
      navigate('/dashboard/studentDataView');
    } else {
      dispatchQuizPageStates({
        type: 'ERROR',
        errorMessage: response.message,
      });
      // reload the page
      window.location.reload();
    }
  };
  return (
    <Fragment>
      <NavHeader title={'الاختبار'} />
      <br />
      <br />
      <div className={styles['container']}>
        {quizArray.map((questionObj) => {
          return (
            <QuizItem
              key={questionObj.index}
              questionObj={questionObj}
              setAnswerTrue={(index) => {
                setAnswersObj({ ...answersObj, [index]: 'true' });
              }}
              setAnswerFalse={(index) => {
                setAnswersObj({ ...answersObj, [index]: 'false' });
              }}
            />
          );
        })}
        {!quizPageStates.pending && (
          <BtnSmall title={'تسليم'} onClick={submitResultsHandler} />
        )}
        {quizPageStates.pending && (
          <BtnSmall
            title={<CircularProgress />}
            onClick={submitResultsHandler}
          />
        )}
        <br></br>
      </div>
      {/* ********** SUCCESS SNACKBAR ********** */}
      <Snackbar
        open={quizPageStates.success}
        onClose={handleCloseSnackbar}
        autoHideDuration={2000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          severity='success'
          onClose={handleCloseSnackbar}
          dir='ltr'
          sx={{
            width: '100%',
            backgroundColor: '#43A047',
            color: '#fff',
            fontSize: '1.4rem',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }}
        >
          !{quizPageStates.successMessage}
        </Alert>
      </Snackbar>
      {/* ********** ERROR SNACKBAR ********** */}
      <Snackbar
        open={quizPageStates.error}
        onClose={handleCloseSnackbar}
        autoHideDuration={20000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          severity='error'
          onClose={handleCloseSnackbar}
          dir='ltr'
          sx={{
            width: '100%',
            backgroundColor: '#D32F2F',
            color: '#fff',
            fontSize: '1.4rem',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }}
        >
          !{quizPageStates.errorMessage}
        </Alert>
      </Snackbar>
    </Fragment>
  );
});

export { QuizPage };
